import React from 'react';
import PropTypes from 'prop-types';

import { DEFAULT_COLORS } from 'constants/colors';
import SvgIcon from 'ravenjs/lib/SvgIcon';

const AddNewIcon = ({ height, viewBox, width, color, setRef, ...rest }) => (
    <SvgIcon {...rest} ref={setRef} width={width} height={height} viewBox={viewBox} fill="none">
        <path
            d="M7.3335 11.3333H8.66683V8.66665H11.3335V7.33331H8.66683V4.66665H7.3335V7.33331H4.66683V8.66665H7.3335V11.3333ZM8.00016 14.6666C7.07794 14.6666 6.21127 14.4916 5.40016 14.1416C4.58905 13.7916 3.8835 13.3166 3.2835 12.7166C2.6835 12.1166 2.2085 11.4111 1.8585 10.6C1.5085 9.78887 1.3335 8.9222 1.3335 7.99998C1.3335 7.07776 1.5085 6.21109 1.8585 5.39998C2.2085 4.58887 2.6835 3.88331 3.2835 3.28331C3.8835 2.68331 4.58905 2.20831 5.40016 1.85831C6.21127 1.50831 7.07794 1.33331 8.00016 1.33331C8.92238 1.33331 9.78905 1.50831 10.6002 1.85831C11.4113 2.20831 12.1168 2.68331 12.7168 3.28331C13.3168 3.88331 13.7918 4.58887 14.1418 5.39998C14.4918 6.21109 14.6668 7.07776 14.6668 7.99998C14.6668 8.9222 14.4918 9.78887 14.1418 10.6C13.7918 11.4111 13.3168 12.1166 12.7168 12.7166C12.1168 13.3166 11.4113 13.7916 10.6002 14.1416C9.78905 14.4916 8.92238 14.6666 8.00016 14.6666Z"
            fill={color}
        />{' '}
    </SvgIcon>
);

AddNewIcon.propTypes = {
    color: PropTypes.string,
    height: PropTypes.string,
    setRef: PropTypes.object,
    viewBox: PropTypes.string,
    width: PropTypes.string,
};

AddNewIcon.defaultProps = {
    color: DEFAULT_COLORS.BLUE_6,
    height: '16',
    setRef: null,
    viewBox: '0 0 16 16',
    width: '16',
};

export default AddNewIcon;
